export default __webpack_public_path__ + "static/media/thunderbolt.ebc3ce88.svg";